// This list is provided by Solventum and the IDs are internal GPCS API IDs.
// Solventum has told us that if this list should change, we will be notified by them directly.
// Insurance ID source-of-truth list: http://apps.3mhis.com/download/3m_Docs_Secured/SharedDocs/grp239_MNE_IDs/MNE_Ins_IDs.txt
// Accessing that doc requires a Solventum support account: https://notable-health.atlassian.net/wiki/spaces/PRODUCT/pages/2961440808/Creating+a+user+account
export const FLOW_MEDICAL_NECESSITY_CHECK_INSURANCE_PROVIDER_ID_LOOKUP = {
    'AK Part A': 84,
    'AK Part B': 2,
    'AL Part A': 3,
    'AL Part B': 4,
    'AR Part A': 85,
    'AR Part B': 5,
    'AZ Part A': 6,
    'AZ Part B': 7,
    'CA Part A': 239,
    'CA-Northern Part B': 9,
    'CA-Southern Part B': 10,
    'CO Part A': 243,
    'CO Part B': 86,
    'CT Part A': 87,
    'CT Part B': 12,
    'DC Part A': 88,
    'DC Part B': 89,
    'DE Part A': 90,
    'DE Part B': 13,
    'DMERC Region A': 133,
    'FL Part A': 14,
    'FL Part B': 15,
    'GA Part A': 16,
    'GA Part B': 17,
    'HI Part A': 240,
    'HI Part B': 18,
    'IA Part A': 19,
    'IA Part B': 20,
    'ID Part A': 21,
    'ID Part B': 22,
    'IL Part A': 23,
    'IL Part B': 24,
    'IN Part A': 25,
    'IN Part B': 26,
    'KS Part A': 27,
    'KS Part B': 92,
    'KY Part A': 28,
    'KY Part B': 29,
    'LA Part A': 30,
    'LA Part B': 31,
    'MA Part A': 32,
    'MA Part B': 33,
    'MD Part A': 34,
    'MD Part B': 35,
    'ME Part A': 93,
    'ME Part B': 94,
    'MI Part A': 36,
    'MI Part B': 37,
    'MN Part A': 38,
    'MN Part B': 39,
    'MO Part A': 95,
    'MO-Eastern Part B': 40,
    'MO-Western Part B': 96,
    'MS Part A': 97,
    'MS Part B': 41,
    'MT Part A': 42,
    'MT Part B': 43,
    'NC Part A': 45,
    'NC Part B': 46,
    'ND Part A': 47,
    'ND Part B': 48,
    'NE Part A': 49,
    'NE Part B': 50,
    'NH Part A': 99,
    'NH Part B': 100,
    'NJ Part A': 51,
    'NJ Part B': 52,
    'NM Part A': 244,
    'NM Part B': 54,
    'NV Part A': 241,
    'NV Part B': 102,
    'NY Part A': 55,
    'NY-Northern Part B': 56,
    'NY-Queens Part B': 103,
    'NY-Southern Part B': 57,
    'OH Part A': 58,
    'OH Part B': 59,
    'OK Part A': 245,
    'OK Part B': 104,
    'OR Part A': 61,
    'OR Part B': 105,
    'PA Part A': 62,
    'PA Part B': 63,
    'PR Part A': 106,
    'PR Part B': 107,
    'RI Part A': 64,
    'RI Part B': 65,
    'SC Part A': 67,
    'SC Part B': 68,
    'SD Part A': 108,
    'SD Part B': 109,
    'TN Part A': 69,
    'TN Part B': 70,
    'TX Part A': 246,
    'TX Part B': 72,
    'UT Part A': 131,
    'UT Part B': 73,
    'VA Part A': 110,
    'VA Part B': 74,
    'VI Part A': 111,
    'VI Part B': 112,
    'VT Part A': 75,
    'VT Part B': 113,
    'WA Part A': 76,
    'WA Part B': 77,
    'WI Part A': 78,
    'WI Part B': 79,
    'WV Part A': 80,
    'WV Part B': 81,
    'WY Part A': 114,
    'WY Part B': 115,
    Aetna: 193,
    'Anthem of VA': 194,
    'BCBS of MA': 143,
    'CA Medicaid': 142,
    'Mutual of Omaha': 44,
    'TX Medicaid': 138,
};
// `z.enum` needs a provably non-empty tuple, which `Object.keys` cannot express
export const FLOW_MEDICAL_NECESSITY_CHECK_INSURANCE_PROVIDER_OPTIONS = Object.keys(FLOW_MEDICAL_NECESSITY_CHECK_INSURANCE_PROVIDER_ID_LOOKUP);
//# sourceMappingURL=insuranceProviders.js.map